import { ChevronsUpDownIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { DropdownMenu, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { SidebarMenuButton, useSidebar } from '@/components/ui/sidebar'
import { useOrgSlug } from '@/hooks/use-org-slug.hook'
import { orgRoutes, settingsRoutes } from '@/routes/org-routes.const'

import { buildNavUrl } from './sidebar-nav-menu-helpers.util'
import { SidebarUserMenuContent } from './sidebar-user-menu-content.molecule'
import { UserAvatarInfo } from './user-avatar-info.atom'

interface SidebarUserMenuProps {
  user: {
    name: string
    email: string
    imageUrl: string | null
  }
  onSignOut: () => void
}

export const SidebarUserMenu = ({ user, onSignOut }: SidebarUserMenuProps): ReactNode => {
  const { isMobile } = useSidebar()
  const orgSlug = useOrgSlug()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SidebarMenuButton
          size="lg"
          className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <UserAvatarInfo name={user.name} email={user.email} imageUrl={user.imageUrl}>
            <ChevronsUpDownIcon className="ml-auto size-4" />
          </UserAvatarInfo>
        </SidebarMenuButton>
      </DropdownMenuTrigger>
      <SidebarUserMenuContent
        user={user}
        isMobile={isMobile}
        profileUrl={buildNavUrl(`/${orgRoutes.profile}/${settingsRoutes.general}`, orgSlug)}
        settingsUrl={buildNavUrl(`/${orgRoutes.settings}`, orgSlug)}
        onSignOut={onSignOut}
      />
    </DropdownMenu>
  )
}
